// src/config.js
const config = {
  // ========================================
  // BACKEND API CONFIGURATION
  // ========================================
  apiBaseUrl: 'https://salesbot-backend-api.varunj.ai/prod-bot',
  
  // ========================================
  // VOICE GATEWAY CONFIGURATION
  // ========================================
  voiceGatewayUrl: 'wss://qa-voice-gateway.varunj.ai',
  voiceGatewayAppId: 'sales-agent', // Must match your app_id in database
  
  // ========================================
  // APPLICATION SETTINGS
  // ========================================
  appName: 'VBL Sales AI Agent',
  companyName: 'VBL',
  
  // ========================================
  // FEATURE FLAGS
  // ========================================
  features: {
    enableSSO: true,
    enableConversationHistory: true,
    enableUserManagement: true,
    enableVoiceMode: true,              // NEW: Enable voice features
  },
  
  // ========================================
  // VOICE SETTINGS
  // ========================================
  voice: {
    defaultLanguage: 'hi-IN',
    supportedLanguages: [
      { code: 'hi-IN', name: 'हिंदी (Hindi)', flag: '🇮🇳' },
      { code: 'en-IN', name: 'English', flag: '🇬🇧' },
      { code: 'ta-IN', name: 'தமிழ் (Tamil)', flag: '🇮🇳' },
      { code: 'te-IN', name: 'తెలుగు (Telugu)', flag: '🇮🇳' },
      { code: 'mr-IN', name: 'मराठी (Marathi)', flag: '🇮🇳' },
    ],
    recordingMaxDuration: 60, // seconds
    audioFormat: 'audio/webm',
  },
  
  // ========================================
  // PAGINATION SETTINGS
  // ========================================
  pagination: {
    conversationsPerPage: 50,
    messagesPerPage: 20,
    dataTableRowsPerPage: 50,
  },
  
  // ========================================
  // TIMEOUT SETTINGS (milliseconds)
  // ========================================
  timeouts: {
    api: 30000,
    query: 120000,
    voiceConnection: 5000,
  },
  
  // ========================================
  // LOCAL STORAGE KEYS
  // ========================================
  storage: {
    tokenKey: 'vbl_sales_token',
    userKey: 'vbl_sales_user',
    themeKey: 'vbl_sales_theme',
    voiceLanguageKey: 'vbl_voice_language',
  },
};

export const getConfig = () => config;

export const validateConfig = () => {
  if (!config.apiBaseUrl) {
    console.error('API Base URL is not configured');
    return false;
  }
  
  console.log('VBL Sales AI Agent Configuration:', {
    apiBaseUrl: config.apiBaseUrl,
    voiceGatewayUrl: config.voiceGatewayUrl,
    appName: config.appName,
    features: config.features,
  });
  
  return true;
};

export default config;
